export const generationApiErrorCodes = {
	unknown: 'unknown',
	// bot
	invalidData: 'invalidData',
	invalidReferenceBot: 'invalidReference',
	unsafeAvatar: 'unsafeAvatar',
	// activate
	invalidBot: 'invalidBot',
	alreadyActive: 'alreadyActive',
	premiumRequired: 'premiumRequired',
	insufficientNeurons: 'insufficientNeurons',
	// create
	limitExceeded: 'limitExceeded',
	// check
	invalidReferenceCheck: 'invalidReference',
	unavailable: 'unavailable',
	unsafe: 'unsafe',
	// images
	// insufficientNeurons: 'insufficientNeurons',
	unsafePrompt: 'unsafePrompt',
	invalidRequest: 'invalidRequest',
} as const;
